import { Page, KpiSkeleton } from '@/components';
import { Flex, Skeleton } from '@blockanalitica/ui';

export default function PageSkeleton() {
  return (
    <Page title={<Skeleton width={150} height="4" />}>
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiSkeleton />
        <KpiSkeleton />
      </Flex>
    </Page>
  );
}
